"use client";

import { Component } from "react";

export class ErrorBoundary extends Component<{
  children: React.ReactNode;
  fallback: React.ComponentType<{ error: Error }>;
}> {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const Fallback = this.props.fallback;

    if (this.state.error) {
      return <Fallback error={this.state.error} />;
    }

    return this.props.children;
  }
}
